import { BITSKI_AUTH_SERVER } from './constants.js';
import { DEV } from 'esm-env';
let CONFIG;
const getCookieSettingsWithDefaults = (cookieSettings) => {
    const overridableCookieSettings = {
        sameSite: 'lax',
    };
    const nonOverridableCookieSettings = DEV
        ? {
            domain: '',
            secure: false,
        }
        : {
            secure: true,
        };
    return {
        authRequestName: 'bsar',
        sessionKeyName: 'bsid',
        deviceIdName: 'fid',
        activeUserIdName: 'bsauid',
        ...cookieSettings,
        serializeOptionsClient: {
            ...overridableCookieSettings,
            ...cookieSettings?.serializeOptionsClient,
            ...nonOverridableCookieSettings,
        },
        serializeOptionsDevice: {
            domain: '.bitski.com',
            ...overridableCookieSettings,
            ...cookieSettings?.serializeOptionsDevice,
            ...nonOverridableCookieSettings,
        },
    };
};
export const getCookieSettings = () => {
    return CONFIG?.cookies ?? getCookieSettingsWithDefaults();
};
export const setConfig = (config) => {
    if (!DEV && !false && CONFIG)
        throw new Error('oauth-proxy-hooks config was set more than once. You can only create one instance of oauth-proxy-hooks per server.');
    const base = config.base ?? '';
    CONFIG = {
        base,
        authServer: BITSKI_AUTH_SERVER,
        durableObjectName: 'OAUTH_SESSION_STORAGE',
        clientIdName: 'OAUTH_CLIENT_ID',
        clientSecretName: 'OAUTH_CLIENT_SECRET',
        oauthLogoutSecretName: 'OAUTH_LOGOUT_SECRET',
        ...config,
        scope: `openid ${config.scope}`,
        routes: {
            login: base + (config.routes?.login ?? '/oauth/login'),
            callback: base + (config.routes?.callback ?? '/oauth/login/callback'),
            logout: base + (config.routes?.logout ?? '/oauth/logout'),
            currentSession: base + (config.routes?.currentSession ?? '/oauth/sessions/current'),
            error: {
                loginRequired: config.routes?.error?.loginRequired
                    ? base + config.routes.error.loginRequired
                    : undefined,
            },
        },
        cookies: getCookieSettingsWithDefaults({
            ...config.cookies,
            serializeOptionsClient: {
                path: `/${base}`,
                ...config.cookies?.serializeOptionsClient,
            },
            serializeOptionsDevice: {
                path: `/${base}`,
                ...config.cookies?.serializeOptionsDevice,
            },
        }),
    };
    return CONFIG;
};
export const getConfig = () => {
    if (!CONFIG)
        throw new Error('oauth-proxy-hooks config was not set. You must create oauth-proxy-hooks in hooks.server.js and hooks.client.js before using it.');
    return CONFIG;
};
